import { CssBaseline, StyledEngineProvider } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
// routing
import Routes from 'routes';

// defaultTheme
import themeConfig from 'configs/themeConfig';
import theme from 'themes';
import customization from 'themes/customize';

// project imports
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/zh-tw';
import NavigationScroll from 'layouts/NavigationScroll';
import { init } from 'utils/methods';

import { ENV_TYPES } from 'configs/constant';
import configs from 'configs/envConfig';
import MainLayout from './layouts/MainLayout';
import { setGAInLocalstorage } from 'trackers/ga';

// ==============================|| APP ||============================== //
// set app viewpoint height

dayjs.extend(weekday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

if (configs.GA_TRACKER_ID)
    ReactGA.initialize(configs.GA_TRACKER_ID, {
        debug: configs.STAGE !== ENV_TYPES.PROD,
        titleCase: false
    });

const App = () => {
    useEffect(() => {
        window.addEventListener('resize', init);
        init();

        const qs = new URLSearchParams(window.location.search);
        const ga_utm_source = qs.get('source');
        const ga_utm_medium = qs.get('medium');
        const ga_utm_campaign = qs.get('campaign');
        setGAInLocalstorage({
            ga_utm_source,
            ga_utm_medium,
            ga_utm_campaign
        });

        return () => {
            window.removeEventListener('resize', init);
        };
    }, []);

    const { defaultIsDarkMode, defaultIsRTL, ...options } = themeConfig || {};
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme(customization, defaultIsDarkMode, defaultIsRTL, options)}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'zh-tw'}>
                    <CssBaseline />
                    <NavigationScroll>
                        <MainLayout>
                            <Routes />
                        </MainLayout>
                    </NavigationScroll>
                </LocalizationProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
